import styles from './styles.module.css';

export const GridWrapper = ({ children }) => {

    return (
        <div className={styles.gridWrapper}>
            {children}
        </div>
    )
}
